module.exports = __webpack_public_path__ + "files/388fbb880f5fa04cb3dab62c79168cc0.svg";